import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import GameMatch from './GameMatch';
import AdminMessageInbox from './AdminMessageInbox';
import AdminMatchRequestInbox from './AdminMatchRequestInbox';
import '../css/GameMatchControlPage.css';
import '../css/MatchControlCommercial.css';
function GameMatchControlPage() {
  const {
    groupId
  } = useParams();
  const navigate = useNavigate();
  const selectedGroupId = Number(groupId);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  });
  useEffect(() => {
    document.body.classList.add('gmc-design-system');
    return () => document.body.classList.remove('gmc-design-system');
  }, []);
  return <main className={`gmc-page gmc-commercial admin-shell-with-sidebar${sidebarCollapsed ? ' is-sidebar-collapsed' : ''}`}>
      <a className="mc-skip-link" href="#match-control-workspace">ข้ามไปพื้นที่จัดการแข่งขัน</a>
      <AdminSidebar active="game-control" groupId={selectedGroupId} compact={sidebarCollapsed} onToggleCompact={() => setSidebarCollapsed(value => !value)} />
      <header className="gmc-header">
        <div className="mc-namad-brand"><img src="/namad-logo12.png" alt="" /><span><b>NAMAD</b><small>BADMINTON</small></span></div>
        <div className="gmc-hero-copy">
          <p><button className="gmc-back-button" type="button" onClick={() => navigate('/dashboard')}>การจัดการสนาม</button><span aria-hidden="true">›</span> Game Match Control</p>
          <h1>จัดแมตช์และควบคุมสนาม</h1>
        </div>
        <div className="gmc-header-tools"><AdminMessageInbox groupId={selectedGroupId} /><AdminMatchRequestInbox groupId={selectedGroupId} /><div className="mc-user"><span aria-hidden="true">{Array.from(user?.name || 'A')[0]}</span><div><strong>{user?.name || 'Admin'}</strong><small>ผู้ดูแลระบบ</small></div></div></div>
        <button className="gmc-group-badge" type="button" onClick={() => navigate('/dashboard')} title="เลือกหรือเปลี่ยนก๊วน"><small>ก๊วนที่กำลังจัดการ</small><b>Group #{selectedGroupId}⌄</b></button>
      </header>
      <section id="match-control-workspace" className="gmc-content" tabIndex={-1}><GameMatch groupId={selectedGroupId} uiVariant="commercial" /></section>
    </main>;
}
export default GameMatchControlPage;
